import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'
import jwt_decode from "jwt-decode";
import { Form, Input ,Select } from 'antd';
import {ButtonBase} from '@mui/material';
import config from '../../config'
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
const { Option } = Select;

export default function CreatUser() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [form] = Form.useForm();


  const onFinish = async (values) => {
    let {
      username: masterName,phNum: phoneNumber,password,
      singleBigMatchCommission,
      singleSmallMatchCommission,
      twoMixParlayCommission,
      threeToEightMixParlayCommission,
      nineToElevenMixParlayCommission
    }  = values;
    setLoading(true)
    if(!phoneNumber) phoneNumber = ""
    const params ={masterName,phoneNumber,password,accountType: 'master',profileImage: "",
                  singleBigMatchCommission,
                  singleSmallMatchCommission,
                  twoMixParlayCommission,
                  threeToEightMixParlayCommission,
                  nineToElevenMixParlayCommission
                  }
    const data = await axios.post(`/master/createMaster`,params)

    let msgObj = { code: data.code, msg: data.message }
    if(data.code == 200){
      msgObj.msg = "Successfully created master account"
      form.resetFields();
    } 
    setErrorMsg(msgObj)
    setLoading(false)
    setOpenAlert(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
 
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        padding: 1rem;
        margin: 0 10rem;
      `}
    >
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        form={form}
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper form={form}/>
        <Lower form={form}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Save</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = ({form}) =>{
  const [agentName,setAgentName] = useState()

  useEffect(()=>{
    const token = localStorage.getItem("token");
    const {name} = jwt_decode(token)
    setAgentName(name)
  })
  const handleUsernameChange = (e) =>{
    form.setFieldsValue({
      username: e.currentTarget.value.toUpperCase().replace(/ /g, '')
    });
  }
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >

        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="username"
          hasFeedback
          rules={[
            {
              required: true,
              message: `Please input username!`,
            },
          ]}
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input size="large" color='rgb(248, 250, 252)' onChange={handleUsernameChange}/>
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number (optional)"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
       
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          style={{ padding: "0 0.4rem", color: "white" }}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please input password!",
            },
            {
              validator: validatePassword
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
         
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
      </div>
    </div>
  );
}

const Lower = ({form}) =>{

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Small Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="singleSmallMatchCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Big Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="singleBigMatchCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
        >
          <Input  size="large" />
        </Form.Item>
       
      
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="2 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="twoMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
        >
          <Input  size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="3 to 8 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="threeToEightMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="9 to 11 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="nineToElevenMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}     
        >
          <Input size="large" />
        </Form.Item>
      </div>
    </div>
  );
}


